/**
 * 销售账单
 * https://www.jianshu.com/p/a3179dbf5b43
 * https://blog.csdn.net/qq_45351419/article/details/111268127
 */

import axios from '@/utils/request'

export default {
  getAdminBilleds: (data) => axios({ url: '/api/payment/bill/getAdminBilleds', method: 'POST', data }), // 获取已出账账单列表(后台)
  getBillDetailsById: (billId, params) => axios({ url: `/api/payment/bill/billedDetail/${billId}`, method: 'GET', params }), // 根据账单ID获取账单详情(前后台同一个接口)
  getUnpublishedBillsList: (data) => axios({ url: '/api/payment/bill/getAdminBills', method: 'POST', data }), // 获取未出账账单列表(后台)
  generateBills: (data) => axios({ url: '/api/payment/bill/billed', method: 'POST', data }), // 生成账单
  getCreditsUserList: (data) => axios({ url: '/api/payment/bill/getCredits', method: 'POST', data }), // 查询信用用户列表
  batchUpdateBillsQty: (data) => axios({ url: '/api/payment/bill/credit/billBatchQty', method: 'PUT', data }), // 批量更新生成账单订单数量
  updateSingleBillsQty: (data) => axios({ url: '/api/payment/bill/credit', method: 'PUT', data }), // 修改单个信用用户
  batchAddCreditUser: (data) => axios({ url: '/api/payment/bill/credit', method: 'POST', data }), // 批量新增信用用户
}
